import React from "react";
import Modal from "react-bootstrap/Modal";
import { Utils } from "../utils";
import { DisputeStatusChip } from "./status";

interface InputProps {
  show: boolean;
  onHide: () => void;
  data: any;
}

const DisputeDetailsPopup: React.FC<InputProps> = ({ show, onHide, data }) => {

  return (
    <Modal
      className="disputeModal detailModal"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-start">
        <div className="d-flex justify-content-between">
          <h3>Details</h3>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6 mb-3">
            <h2>Subject:</h2>
            <p>{data?.subject}</p>
          </div>
          <div className="col-md-6 mb-3">
            <h2>Status:</h2>
            <p>
              <DisputeStatusChip status={data?.status} />
            </p>
          </div>
          <div className="col-md-6 mb-3">
            <h2>Artwork:</h2>
            <p>{data?.adId?.title}</p>
          </div>
          <div className="col-md-6 mb-3">
            <h2>Type:</h2>
            <p>{data?.typeId?.name}</p>
          </div>
          <div className="col-12 mb-3">
            <h2>Message:</h2>
            <p>{data?.message}</p>
          </div>
          <div className="col-md-6 mb-3">
            <h2>Created at:</h2>
            <p className="primaryColor">
              {Utils.formatDateTime(data?.createdAt)}
            </p>
          </div>
          <div className="col-md-6 mb-3">
            <h2>Last updated:</h2>
            <p className="primaryColor">
              {Utils.formatDateTime(data?.updatedAt)}
            </p>
          </div>
          {data?.file && (
            <div className="col-12 mb-3">
              <h2>Attachment:</h2>
              {data.file.match(/\.(png|jpe?g)$/i) ? (
                <a href={data.file} target="_blank" rel="noopener noreferrer">
                  <img
                    src={data.file}
                    alt="Attachment"
                    style={{
                      maxWidth: "100%",
                      maxHeight: 200,
                      objectFit: "contain",
                      borderRadius: 4,
                    }}
                  />
                </a>
              ) : (
                <a href={data.file} target="_blank" rel="noopener noreferrer">
                  View attached file
                </a>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DisputeDetailsPopup;
